<div id="cookie-settings">
  <mui-modal-header [title]="'cookieSettings.dialog.title' | translate" [hideCloseButton]="true"></mui-modal-header>
  <div class="mui-modal__body cookie-details-body">
    <p [innerHTML]="'cookieSettings.dialog.description' | translate: { moreInfoLink: safeMoreInfoAnchor }"></p>
    <div class="link-list">
      <a href="/user/legal/data-privacy" target="_blank">{{ 'global.footer.dataPrivacy' | translate }}</a>
      <a href="/user/legal/imprint" target="_blank">{{ 'global.footer.imprint' | translate }}</a>
      <a href="/user/legal/cookie-notice" target="_blank">{{ 'global.footer.cookieNotice' | translate }}</a>
    </div>
    <mmu-global-privacy-control-hint
      (disableAnalyticsCookies)="acceptRequiredCookies()"></mmu-global-privacy-control-hint>
    <mmu-cookie-buttons
      #allowAllButton
      (acceptRequiredCookies)="acceptRequiredCookies()"
      (acceptAllCookies)="acceptAllCookies()">
    </mmu-cookie-buttons>
  </div>
</div>
